var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Loading data from JotForms ...")]),_c('v-progress-circular',{staticStyle:{"margin-left":"auto","display":"block","margin-right":"auto"},attrs:{"indeterminate":"","color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }